import React from 'react';
import styled from 'styled-components';
import { Button as MUIButton, ButtonProps } from '@material-ui/core';

interface IProps extends ButtonProps {
    showActive?: boolean;
}

const BaseButton = ({ showActive, ...props }: IProps) => (
    <MUIButton {...props} />
);

export const ActionButton = styled(BaseButton)`
    height: 44px;
    background-color: ${({ showActive, theme }) =>
        showActive ? theme.palette.primary.main : theme.palette.grey[50]};
    color: ${({ showActive, theme }) =>
        showActive
            ? theme.palette.background.paper
            : theme.palette.primary.main};
    border-radius: 20px;
    text-transform: none;
    padding: 0 40px;
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    :hover {
        background-color: ${({ theme }) => theme.palette.grey[200]};
    }
    :disabled {
        background-color: ${({ theme }) => theme.palette.action.disabled};
        color: ${({ theme }) => theme.palette.background.paper};
    }
`;
